import React, { Component } from 'react';
import { withRouter } from 'react-router';
import camelize from 'camelize';
import megaMenu from 'styleguide/resources/assets/js/mega-menu';
import NavItem from './NavItem';
import {
  MyAccount,
  Login,
  Signup,
  NavCartAuthenticated,
  NavCartUnauthenticated,
  NavCartAuthenticatedMtyCart,
} from './NavAccount';
import config from '../../config';
import SideBar from './SideBar';
import {
  NavButton,
  NavImgButton,
  NavFlag as NavFlagBase,
} from './ViewComponents';
import { LanguageSelector as NavLanguageSelector } from './NavLanguage';
import { connectUserHeaderinfo } from '../Auth/WithUserHeaderInfo';
import { forDesktopOnly } from '../Common/Helper';
import { withStoreDetail } from '../Common/Providers/WithStoreDetail';
import { withTranslation, TransLink } from '../Common/Translations';
import { withResizeHelper } from '../Common/ResizeHelper';
import AutoCompleteSearchBar from './AutoCompleteSearchBar';
import AutoCompleteSearchBarMobile from './AutoCompleteSearchBarMobile';
import { compose } from 'recompose';
import withGlobalShippingCredit from '../GlobalShippingCredit/withGlobalShippingCredit';

const HelpButton = forDesktopOnly(NavButton);
const PassButton = forDesktopOnly(NavImgButton);
const PbLiveButton = forDesktopOnly(NavImgButton);
const NavFlag = forDesktopOnly(NavFlagBase);
const NavLanguage = forDesktopOnly(NavLanguageSelector);
const AutoCompleteSearchBarNonMobile = forDesktopOnly(AutoCompleteSearchBar);

function handleSuccess(response) {
  this.setState({ menus: camelize(response.data) });
}

function initMenuHoverFunction() {
  $('.dropdown-toggle').megaMenu({ container: '.mmd' });
}

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.openSideBar = this.openSideBar.bind(this);
    this.closeSideBar = this.closeSideBar.bind(this);
    this.updateViewport = this.updateViewport.bind(this);

    $.fn.megaMenu = megaMenu;
  }

  state = {
    menus: [],
    isSideBarOpen: false,
    isDesktop: window.innerWidth >= 992,
  };

  closeSideBar() {
    this.setState({ isSideBarOpen: false });
  }

  openSideBar() {
    this.setState({ isSideBarOpen: true });
  }

  updateViewport() {
    this.setState({
      isDesktop:
        this.props.breakpoint === 'lg' || this.props.breakpoint === 'xl',
    });
  }

  isPromotion(index) {
    return this.state.menus[index].href === '/promotions';
  }

  /* Map country name for "Muslim Pro" and "Personalise me" from storeCode */
  countryName(storeCode, storeName) {
    let countryName = '';
    const country = {
      MY: { name: 'Malaysia' },
      ID: { name: 'Indonesia' },
      EU: { name: 'Europe' },
      US: { name: 'USA' },
      UK: { name: 'United Kingdom' },
    };
    if (storeCode !== 'undefined') {
      const cca2 = storeCode.substring(2);
      countryName = country[cca2] ? country[cca2].name : storeName.slice(10);
    }
    return countryName;
  }

  componentDidMount() {
    $.get(`${config.localeApi}/menu`, handleSuccess.bind(this)).fail(
      (response) => console.log('fail', response)
    ); // eslint-disable-line no-console
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.breakpoint &&
      this.props.breakpoint !== prevProps.breakpoint
    ) {
      this.updateViewport();
    }
    if (this.state.isDesktop) {
      initMenuHoverFunction();
    }
  }

  render() {
    const {
      userHeaderInfo: { numOfItemsInCart = 0, isSubscriber = false },
      store,
    } = this.props;
    const countryName = this.countryName(`${store.code}`, `${store.name}`);
    const navItems = this.state.menus.map((menu, index) => (
      <NavItem
        key={index}
        {...menu}
        isPromotion={this.isPromotion(index)}
        {...this.props}
      />
    ));
    const passLink = isSubscriber ? '/account/dashboard/pass' : '/pass';

    return (
      <div className="container header__container--mw mx-auto">
        <nav className="navbar navbar-expand px-0">
          <div className="w-100 d-flex align-items-center justify-content-md-between">
            <div className="d-flex col align-self-center px-0">
              <SideBar
                logo={`${config.s3BucketUrl}/assets/general/pb-logo-colour-top-nav.png`}
                menus={this.state.menus}
                sideBarOpen={this.props.sideBarOpen}
                toggleSidebar={this.props.toggleSidebar}
                {...this.props}
              />
              <a href="/">
                <img
                  className="nav__logo--size mx-auto"
                  id="logo"
                  src={`${config.s3BucketUrl}/assets/general/pb-logo-colour-top-nav.png`}
                  alt={store.name}
                  width="180"
                />
              </a>
            </div>
            <div
              className="col pr-0 justify-content-end collapse navbar-collapse"
              id="secondNav"
            >
              <Login />
              <Signup />
              <MyAccount {...this.props} />
              {store.has_active_subscriptions && (
                <TransLink url={passLink}>
                  <PassButton
                    src={`${config.s3BucketUrl}/subscriptions/pass-logo.png`}
                    width="88"
                    height="16"
                    style={{ height: '1rem' }}
                    alt="Photobook Pass"
                  />
                </TransLink>
              )}
              <TransLink
                url={`${config.trackerUrl}/track?redirect=${encodeURIComponent(
                  config.pbLiveUrl
                )}`}
                target="_blank"
              >
                <PbLiveButton
                  src={`${config.s3BucketUrl}/logos/pb-live-logo.51e37b9e69b32f14e6f92042717fb961.svg`}
                  width="88"
                  height="16"
                  style={{ height: '1.25rem' }}
                  alt="Photobook Live"
                />
              </TransLink>
              <NavFlag
                flag={store.flag}
                countryName={countryName}
                currency={`${store.currency.code}`}
              />
              {this.props.languages.length > 1 && (
                <NavLanguage languages={this.props.languages} />
              )}
              {numOfItemsInCart < 1 && <NavCartAuthenticatedMtyCart disabled />}
              {numOfItemsInCart > 0 && (
                <NavCartAuthenticated>
                  <span className="align-top badge badge-pill badge-secondary">
                    {numOfItemsInCart}
                  </span>
                </NavCartAuthenticated>
              )}
              <NavCartUnauthenticated />
              <TransLink url="/faq">
                <HelpButton>
                  <img
                    src="/img/svg/help.svg"
                    className="Help"
                    id="help__img"
                    alt="Help"
                  />
                </HelpButton>
              </TransLink>

              <AutoCompleteSearchBarNonMobile {...this.props} />
              <AutoCompleteSearchBarMobile {...this.props} />
            </div>
          </div>
        </nav>
        <div className="hline-bottom">
          {this.state.isDesktop && (
            <nav className="mmd navbar navbar-expand-lg">
              <ul className="navbar-nav">{navItems}</ul>
            </nav>
          )}
        </div>
      </div>
    );
  }
}

export default compose(
  withTranslation('navbar'),
  connectUserHeaderinfo,
  withStoreDetail,
  withRouter,
  withResizeHelper,
  withGlobalShippingCredit
)(Navbar);

export const undecorated = Navbar;



// WEBPACK FOOTER //
// ./src/Nav/Navbar.js